import { parsePropertyIds } from './plp';

export const PLP_FILTER_KEYS = ['properties', 'min-price', 'max-price', 'newOnly'] as const;
export type PlpQuery = Record<string, any>;

export function hasPlpFilters(query: PlpQuery): boolean {
    return PLP_FILTER_KEYS.some(key => query[key] != null && query[key] !== '');
}

export function clearPlpFilters(query: PlpQuery): PlpQuery {
    const next = { ...query };
    for (const key of PLP_FILTER_KEYS) delete next[key];
    delete next.p;
    return next;
}

export function departmentFromPath(path: string): 'dames' | 'heren' | undefined {
    return path
        .toLowerCase()
        .split('/')
        .find(part => part === 'dames' || part === 'heren') as any;
}

export function categoryNavigationQuery(
    source: PlpQuery,
    target: PlpQuery,
    sourceDepartment?: string,
    targetDepartment?: string,
): PlpQuery {
    const next = { ...target };
    // Destination controls category, search and campaign context. Never copy tn_cid
    // or variant from the old category onto a new SEO route.
    for (const key of [...PLP_FILTER_KEYS, 'sort']) {
        if (source[key] != null && source[key] !== '') next[key] = source[key];
        else delete next[key];
    }
    if (sourceDepartment && targetDepartment && sourceDepartment !== targetDepartment) {
        for (const key of PLP_FILTER_KEYS) delete next[key];
    }
    delete next.p;
    return next;
}

/** Labels remain recoverable on shared zero-result URLs without a facet response. */
export function propertyLabel(id: string): string {
    if (!/^(?:[a-f0-9]{2})+$/i.test(id)) return 'Onbekend filter';
    try {
        const bytes = new Uint8Array(id.match(/.{2}/g)!.map(byte => parseInt(byte, 16)));
        const decoded = new TextDecoder().decode(bytes);
        const match = decoded.match(/^tw\|[^|]+\|(.+)$/s);
        return match?.[1] || 'Onbekend filter';
    } catch {
        return 'Onbekend filter';
    }
}

export function navigationFilterQuery(query: PlpQuery): PlpQuery {
    const filters: PlpQuery = {};
    for (const key of PLP_FILTER_KEYS) {
        if (typeof query[key] === 'string' && query[key] !== '') filters[key] = query[key];
    }
    if (filters.properties) filters.properties = [...new Set(parsePropertyIds(filters.properties))].sort().join('|');
    return filters;
}
